import React from 'react';

class Radios extends React.Component {
  state = { value: '' };

  componentDidMount() {
    this.setState({ value: this.props.value || '' });
  }

  handleChange = (event) => {
    this.setState({ value: event.target.value });
    this.props.updateValue(event);
  }

  render() {
    const { field } = this.props;
    if (!field || !field.options || !field.options.length) {
      return null;
    }
    return (
      <div className="relative mb-1">
        {
          field.options.map(option => {
            const id = `${this.props.name}-${option.value}`;
            return (
              <label htmlFor={id} key={option.value} className="block cursor-pointer text-gray-700 mb-1 py-1">
                <input
                  className="mr-3 leading-tight"
                  onChange={this.handleChange}
                  name={this.props.name}
                  id={id}
                  value={option.value}
                  type="radio"
                  disabled={!!this.props.submitting}
                  checked={option.value === this.state.value}
                />
                <span className="text-sm font-normal">{option.label}</span>
              </label>
            );
          })
        }
      </div>
    );
  }
};

export default Radios;